import React, { useState, useEffect } from "react";
import { Modal, Button, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const WelcomeModal = () => {
  // State to control the modal visibility
  const [opened, setOpened] = useState(true);

  useEffect(() => {
    setOpened(true);
  }, []);

  const handleContinue = () => {
    setOpened(false)
    // Show notification
    notifications.show({
      title: "Scroll to see more!",
      message: "Scroll up to view pins and development models",
      position: "bottom-center",
      autoClose: 20000,
      radius: "md",
      color: "rgba(255, 255, 255, 0)",
      icon: (
        <DotLottieReact
          src="https://lottie.host/2977ffe4-2c2f-4d6e-8bc1-54ba419a2a1d/HXGL0g7tFO.lottie"
          loop
          autoplay
          style={{
            transform: "rotate(180deg)",
            width: "60px",
            height: "80px",
          }}
        />
      ),
    });
  };

  return (
    <div>
      {/* Modal Component */}
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Welcome"
        size="lg"
        overlayProps={{
          color: "rgba(216, 235, 227, 0.6)",
          opacity: 2,
          blur: 3,
        }}
        centered
      >
        <Text size="md">
          This 3D map displays development permits lodged within our Local
          Government Area. Information is sourced from Council’s planning system
          to visualise the location and cumulative impact of submitted and
          approved permits.
        </Text>
        <Text size="md" style={{ marginTop: 10 }}>
          Currently the map only represents residential developments. Our team
          is working to update the map with applications and models for mixed-use
          and commercial developments.
        </Text>
        <Text size="md" style={{ marginTop: 10 }}>
          All 3D Building models in the map are simplified interpretations of
          existing buildings and residential developments. This data should not
          be used for planning purposes.
        </Text>
        <Text size="md" style={{ marginTop: 10 }}>
          This tool displays limited information about planning permit
          applications, for complete information please go to{" "}
          <a href="https://www.portphillip.vic.gov.au/" target="_blank" rel="noopener noreferrer">
            MyPortPhillip
          </a>
        </Text>
        <div
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}
        >
          <Button onClick={handleContinue} variant="default">
            Continue
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default WelcomeModal;
